<div class="container">
  <div class="close" (click)="closeDialog()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <h1 class="title">
    {{ showMessage ? 'Cambiaste la contraseña' : 'Cambiar contraseña de Commerce' }}
  </h1>
  <form
    [formGroup]="formGroup"
    class="form"
    *ngIf="!showMessage"
    (keyup.enter)="changePassword()"
    autocomplete="off"
  >
    <mat-form-field appearance="outline">
      <mat-label>Nueva contraseña</mat-label>
      <input
        matInput
        [type]="hideNewPassword ? 'password' : 'text'"
        name="newPassword"
        formControlName="newPasswordControl"
        [readonly]="loading"
        autocomplete="new-password"
        (keyup)="checkForMatch()"
      />
      <div *ngIf="formGroup.controls.newPasswordControl.value.length > 0">
        <img
          class="eye-icon"
          src="assets/icons/eye.svg"
          *ngIf="!hideNewPassword"
          (click)="hideNewPassword = true"
          alt=""
        />
        <img
          class="eye-off-icon"
          src="assets/icons/eye-off.svg"
          *ngIf="hideNewPassword"
          (click)="hideNewPassword = false"
          alt=""
        />
      </div>
      <mat-error
        for="newPassword"
        class="form-error"
        *ngIf="
          (!formGroup.controls.newPasswordControl.pristine ||
            formGroup.controls.newPasswordControl.touched) &&
          formGroup.controls.newPasswordControl.invalid
        "
      >
        {{ getErrorMessage('newPasswordControl') }}
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Repetir contraseña</mat-label>
      <input
        [type]="hideRepeatPassword ? 'password' : 'text'"
        matInput
        name="repeatPassword"
        formControlName="repeatPasswordControl"
        [readonly]="loading"
        autocomplete="new-password"
      />
      <div *ngIf="formGroup.controls.repeatPasswordControl.value.length > 0">
        <img
          class="eye-icon"
          src="assets/icons/eye.svg"
          *ngIf="!hideRepeatPassword"
          (click)="hideRepeatPassword = true"
          alt=""
        />
        <img
          class="eye-off-icon"
          src="assets/icons/eye-off.svg"
          *ngIf="hideRepeatPassword"
          (click)="hideRepeatPassword = false"
          alt=""
        />
      </div>
      <mat-error
        for="repeatPassword"
        *ngIf="
          (!formGroup.controls.repeatPasswordControl.pristine ||
            formGroup.controls.repeatPasswordControl.touched) &&
          formGroup.controls.repeatPasswordControl.invalid
        "
      >
        {{ getErrorMessage('repeatPasswordControl') }}
      </mat-error>
    </mat-form-field>
    <button [disabled]="loading" class="td-btn primary" (click)="changePassword()">Cambiar</button>
  </form>
  <div class="message" *ngIf="showMessage">
    <img src="/assets/icons/circular-tick.svg" alt="correct" />
  </div>
</div>
